export var HEADER_TYPE;
(function (HEADER_TYPE) {
    HEADER_TYPE["Public"] = "public";
    HEADER_TYPE["Private"] = "private";
    HEADER_TYPE["Integrated"] = "integrated";
})(HEADER_TYPE || (HEADER_TYPE = {}));
export var ACTION_TYPE;
(function (ACTION_TYPE) {
    ACTION_TYPE["Login"] = "login";
    ACTION_TYPE["Registration"] = "registration";
})(ACTION_TYPE || (ACTION_TYPE = {}));
export var MENU_LAYOUT;
(function (MENU_LAYOUT) {
    MENU_LAYOUT["Even"] = "even";
    MENU_LAYOUT["Default"] = "default";
})(MENU_LAYOUT || (MENU_LAYOUT = {}));
export var MENU_TYPE;
(function (MENU_TYPE) {
    MENU_TYPE["Basic"] = "basic";
    MENU_TYPE["Advanced"] = "advanced";
    MENU_TYPE["Text"] = "text";
    MENU_TYPE["Image"] = "image";
    MENU_TYPE["Arrow"] = "arrow";
})(MENU_TYPE || (MENU_TYPE = {}));
//# sourceMappingURL=types.js.map